/*
 * Copyright (c) 2025, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

export const SUPPORT_DEVELOPMENT_URL = "https://github.com/autobrr/qui#support-development"
export const SUPPORT_CRYPTOCURRENCY_URL = "https://github.com/autobrr/qui#cryptocurrency"
export const QUI_DISCORD_URL = "https://discord.autobrr.com/qui"

